<template>
  <div>
    <div :class="$style.head">
      <div :class="$style.headItem" class="mb-3 pr-3">
        <div :class="$style.headIcon" class="bg-light text-dark mr-3">
          <i class="fe fe-menu font-size-18" />
        </div>
        <div>
          <div class="text-uppercase text-muted text-nowrap">Jumlah Data</div>
          <div class="font-weight-bold text-dark">
            {{ pagination.total }}
          </div>
        </div>
        <!-- <div class="mb-4">
          <a-upload :multiple="false" name="myFile" @change="convertTable">
            <a-icon type="plus" />
            <div class="ant-upload-text">Upload</div>
          </a-upload>
        </div> -->
      </div>
    </div>
    <a-divider />
    <div class="d-inline-block mr-2 mt-3 mt-sm-0 mb-3 mb-sm-3">
      <label><strong> Cari berdasarkan kode pasien </strong></label> <br />
      <a-input-search
        style="width: 200px; border: 1px solid black; border-radius: 4px"
        placeholder="Search by code..."
        v-model="filterBycode"
        @search="onSearch"
      />
    </div>
    <div class="d-inline-block mr-2 mt-3 mt-sm-0 mb-3 mb-sm-3">
      <label><strong> Filter Program </strong></label> <br />
      <a-select
        style="
          width: 180px;
          z-index: 99;
          border: 1px solid black;
          border-radius: 4px;
          margin-right: 10px;
        "
        placeholder="Pilih Program"
        v-model="filterProgram"
        @change="handleChangeProgram"
      >
        <a-select-option :key="'Semua'" :value="'Semua'">
          Semua
        </a-select-option>
        <a-select-option
          v-for="(i, index) in programTypeItems"
          :key="index"
          :value="i.name"
        >
          {{ i.name }}
        </a-select-option>
      </a-select>
    </div>
    <div class="d-inline-block mr-2 mt-3 mt-sm-0 mb-3 mb-sm-3">
      <label><strong> Filter Bulan PO Date </strong></label> <br />
      <a-select
        v-model="poDateMonth"
        allow-clear
        placeholder="Pilih bulan PO date"
        style="
          width: 180px;
          z-index: 99;
          border: 1px solid black;
          border-radius: 4px;
        "
        @change="onPoDateMonthChanged"
      >
        <a-select-option v-for="(m, i) in months" :key="i" :value="`${i + 1}`">
          {{ capitalizeFirstLetter(m) }}
        </a-select-option>
      </a-select>
    </div>
    <div class="d-inline-block mr-2 mt-3 mt-sm-0 mb-3 mb-sm-3">
      <a-button @click="bulkDownloadData" :loading="isLoading"
        >Download Sesuai Filter</a-button
      >
    </div>
    <div
      style="z-index: 99"
      class="d-inline-block float-right mt-3 mt-sm-0 mb-3 mx-2 mb-sm-3"
    >
      <label class="float-left text-left"
        ><strong> Filter bulan program pertama </strong></label
      >
      <br />
      <a-select
        v-model="month"
        :disabled="!year"
        mode="multiple"
        allow-clear
        :max-tag-count="2"
        placeholder="Pilih bulan program"
        style="
          width: 240px;
          z-index: 99;
          border: 1px solid black;
          border-radius: 4px;
        "
        @change="onMonthChanged"
      >
        <a-select-option v-for="(m, i) in months" :key="i" :value="`${i + 1}`">
          {{ capitalizeFirstLetter(m) }}
        </a-select-option>
      </a-select>
    </div>
    <div
      style="z-index: 99"
      class="d-inline-block float-right mt-3 mt-sm-0 mb-3 mb-sm-3"
    >
      <label class="float-left text-left"
        ><strong> Filter tahun program pertama </strong></label
      >
      <br />
      <a-select
        v-model="year"
        style="
          width: 180px;
          z-index: 99;
          border: 1px solid black;
          border-radius: 4px;
        "
        @change="onYearChanged"
      >
        <a-select-option value="">Semua</a-select-option>
        <a-select-option v-for="y in availableYears" :key="y" :value="y">
          {{ y }}
        </a-select-option>
      </a-select>
    </div>

    <!-- <div
      style="z-index: 99"
      class="d-inline-block mt-3 mt-sm-0 mb-3 mx-2 float-right mb-sm-3"
    >
      <label class="float-left text-left"
        ><strong> Filter by City </strong></label
      >
      <br />
      <a-select
        v-model="selectedCityFilter"
        style="
          width: 180px;
          z-index: 99;
          border: 1px solid black;
          border-radius: 4px;
        "
        @change="onFilter(items)"
        mode="multiple"
      >
        <a-select-option
          v-for="(city, i) in cityFilters"
          :label="city"
          :key="i"
          :value="city"
        >
          {{ city }}
        </a-select-option>
      </a-select>
    </div> -->
    <div
      style="z-index: 99"
      class="d-inline-block mt-3 mt-sm-0 mb-3 mx-2 float-right mb-sm-3"
    >
      <label class="float-left text-left"
        ><strong> Filter by Pharmacy </strong></label
      >
      <br />
      <a-select
        v-model="selectedPharmacyFilters"
        placeholder="Cari atau pilih farmasi"
        style="
          width: 260px;
          z-index: 99;
          border: 1px solid black;
          border-radius: 4px;
        "
        mode="multiple"
        show-search
        allow-clear
        option-filter-prop="label"
        option-label-prop="label"
        :max-tag-count="2"
        :max-tag-placeholder="getPharmacyTagPlaceholder"
        not-found-content="Farmasi tidak ditemukan"
        @change="onPharmacyChanged"
      >
        <a-select-option
          v-for="pharmacy in pharmacyItems"
          :label="getPharmacyLabel(pharmacy)"
          :key="pharmacy.id"
          :value="pharmacy.id"
        >
          {{ getPharmacyLabel(pharmacy) }}
        </a-select-option>
      </a-select>
    </div>
    <div
      style="z-index: 99"
      class="d-inline-block mt-3 mt-sm-0 mb-3 mx-2 float-right mb-sm-3"
    >
      <label class="float-left text-left"
        ><strong> Filter by Status </strong></label
      >
      <br />
      <a-select
        v-model="selectedStatusFilters"
        style="
          width: 180px;
          z-index: 99;
          border: 1px solid black;
          border-radius: 4px;
        "
        @change="onStatusChanged"
      >
        <a-select-option key="all" value="">
          <strong>Semua Status</strong>
        </a-select-option>
        <a-select-option key="not_yet" value="not_yet">
          Belum Terdaftar
        </a-select-option>
        <a-select-option key="un_scanned" value="un_scanned">
          Belum Scan QR
        </a-select-option>
        <a-select-option key="not_active" value="not_active">
          Tidak Aktif
        </a-select-option>
        <a-select-option key="reactive" value="reactive">
          Reactive
        </a-select-option>
        <a-select-option key="new_patient" value="new_patient">
          Pasien Baru
        </a-select-option>
        <a-select-option key="stop" value="stop"> Berhenti </a-select-option>
        <a-select-option key="continuing" value="continuing">
          Perpanjang
        </a-select-option>
      </a-select>
    </div>
    <!-- <div
      style="z-index: 99"
      class="d-inline-block mt-3 mt-sm-0 mb-3 mx-2 float-right mb-sm-3"
    >
      <label class="float-left text-left"
        ><strong> Filter by Alasan Berhenti </strong></label
      >
      <br />
      <a-select
        v-model="selectedDeathCauseFilters"
        style="
          width: 180px;
          z-index: 99;
          border: 1px solid black;
          border-radius: 4px;
        "
        @change="onFilter(items)"
        mode="multiple"
      >
        <a-select-option
          v-for="(deathCause, i) in deathCauseFilters"
          :key="i"
          :value="deathCause"
        >
          {{ deathCause }}
        </a-select-option>
      </a-select>
    </div> -->
    <!-- <div
      style="z-index: 99"
      class="d-inline-block mt-3 mt-sm-0 mb-3 mx-2 float-right mb-sm-3"
    >
      <label class="float-left text-left"
        ><strong> Filter by Doctor </strong></label
      >
      <br />
      <a-select
        v-model="selectedDoctorFilter"
        style="
          width: 220px;
          z-index: 99;
          border: 1px solid black;
          border-radius: 4px;
        "
        @change="onFilter(items)"
        mode="multiple"
      >
        <a-select-option
          v-for="(doctor, i) in doctorFilters"
          :key="i"
          :value="doctor"
        >
          {{ doctor }}
        </a-select-option>
      </a-select>
    </div> -->
    <div class="mb-4" style="z-index: 1">
      <a-modal :footer="null" v-model="visible">
        <span slot="title"
          ><strong> Daftar obat yang sudah diminum </strong>
        </span>
        <a-list
          :class="$style.scroll"
          item-layout="horizontal"
          :data-source="pills"
        >
          <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta>
              <a v-if="item.hour != null" slot="title"
                ><strong
                  >Obat sudah diminum pada pukul {{ item.hour }}:{{
                    item.minute
                  }}.
                  <span class="float-right mr-3">{{
                    moment(item.createdAt).format('YYYY-MM-DD')
                  }}</span></strong
                ></a
              >
              <a v-else slot="title"
                >Obat belum diminum.
                <strong>
                  <span class="float-right mr-3">{{
                    moment(item.createdAt).format('YYYY-MM-DD')
                  }}</span></strong
                ></a
              >
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </a-modal>
      <a-modal
        :footer="null"
        v-model="modalRedemption"
        width="100vw"
        @cancel="() => handleCloseModalRedemp()"
      >
        <a-table
          :columns="columnsRedemption"
          :dataSource="selectedRedemptionRecord"
          style="margin-top: 15px"
          :pagination="false"
          rowKey="id"
        >
          <template slot="mad" slot-scope="mad, record">
            <div class="justify-content-between" v-if="record.takenpills">
              <a
                @click="showModal(record)"
                class="kit__utils__link font-size-16 mr-3"
                >{{ parseFloat(mad).toFixed(2) }}%</a
              >
              <strong style="font-size: 20px" class="float-right"
                ><sup>{{ record.takenpills }}</sup
                >&frasl;<sub>{{ record.prescription }}</sub></strong
              >
            </div>
            <a-tag color="volcano" v-else><a-icon type="minus"></a-icon></a-tag>
          </template>
          <template slot="januari" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </div>

            <!-- {{ text }} <br /> -->
            <!-- {{ record.januariPriceName }} -->
          </template>
          <template slot="februari" slot-scope="text">
            <li
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </li>

            <!-- {{ text }} <br />
            {{ record.februariPriceName }} -->
          </template>
          <template slot="maret" slot-scope="text">
            <li
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </li>

            <!-- {{ text }} <br />
            {{ record.maretPriceName }} -->
          </template>
          <template slot="april" slot-scope="text">
            <li
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </li>

            <!-- {{ text }} <br />
            {{ record.aprilPriceName }} -->
          </template>
          <template slot="mei" slot-scope="text">
            <li
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </li>

            <!-- {{ text }} <br />
            {{ record.meiPriceName }} -->
          </template>
          <template slot="juni" slot-scope="text">
            <li
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </li>

            <!-- {{ text }} <br />
            {{ record.juniPriceName }} -->
          </template>
          <template slot="juli" slot-scope="text">
            <li
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </li>

            <!-- {{ text }} <br />
            {{ record.juliPriceName }} -->
          </template>
          <template slot="agustus" slot-scope="text">
            <li
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </li>

            <!-- {{ text }} <br />
            {{ record.agustusPriceName }} -->
          </template>
          <template slot="september" slot-scope="text">
            <li
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </li>

            <!-- {{ text }} <br />
            {{ record.septemberPriceName }} -->
          </template>
          <template slot="oktober" slot-scope="text">
            <li
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </li>

            <!-- {{ text }} <br />
            {{ record.oktoberPriceName }} -->
          </template>
          <template slot="november" slot-scope="text">
            <li
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </li>

            <!-- {{ text }} <br />
            {{ record.novemberPriceName }} -->
          </template>
          <template slot="desember" slot-scope="text">
            <li
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </li>

            <!-- {{ text }} <br />
            {{ record.desemberPriceName }} -->
          </template>
        </a-table>
      </a-modal>
      <a-modal
        :footer="null"
        v-model="modalVerif"
        width="100vw"
        @cancel="() => handleCloseModalVerif()"
      >
        <a-table
          :columns="columnsVerif"
          :dataSource="selectedVerifRecord"
          style="margin-top: 15px"
          :pagination="false"
          rowKey="id"
        >
          <template slot="mad" slot-scope="mad, record">
            <div class="justify-content-between" v-if="record.takenpills">
              <a
                @click="showModal(record)"
                class="kit__utils__link font-size-16 mr-3"
                >{{ parseFloat(mad).toFixed(2) }}%</a
              >
              <strong style="font-size: 20px" class="float-right"
                ><sup>{{ record.takenpills }}</sup
                >&frasl;<sub>{{ record.prescription }}</sub></strong
              >
            </div>
            <a-tag color="volcano" v-else><a-icon type="minus"></a-icon></a-tag>
          </template>
          <template slot="januari" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </div>
            <!-- {{ record.januariPriceName }} -->
          </template>
          <template slot="februari" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </div>
            <!-- {{ record.februariPriceName }} -->
          </template>
          <template slot="maret" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </div>
            <!-- {{ record.maretPriceName }} -->
          </template>
          <template slot="april" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </div>
            <!-- {{ record.aprilPriceName }} -->
          </template>
          <template slot="mei" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </div>
            <!-- {{ record.meiPriceName }} -->
          </template>
          <template slot="juni" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </div>
            <!-- {{ record.juniPriceName }} -->
          </template>
          <template slot="juli" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </div>
            <!-- {{ record.juliPriceName }} -->
          </template>
          <template slot="agustus" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </div>
            <!-- {{ record.agustusPriceName }} -->
          </template>
          <template slot="september" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </div>
            <!-- {{ .septemberPriceName }} -->
          </template>
          <template slot="oktober" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </div>
            <!-- {{ .oktoberPriceName }} -->
          </template>
          <template slot="november" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </div>
            <!-- {{ .novemberPriceName }} -->
          </template>
          <template slot="desember" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item.date }}</div>
              <span>{{ item.price }}</span>
            </div>
            <!-- {{ .desemberPriceName }} -->
          </template>
        </a-table>
      </a-modal>
      <a-modal
        :footer="null"
        v-model="modalPerpanjang"
        width="100vw"
        @cancel="() => handleCloseModalPerpanjang()"
      >
        <a-table
          :columns="columnsPerpanjang"
          :dataSource="selectedPerpanjangRecord"
          style="margin-top: 15px"
          :pagination="false"
          rowKey="id"
        >
          <template slot="mad" slot-scope="mad, record">
            <div class="justify-content-between" v-if="record.takenpills">
              <a
                @click="showModal(record)"
                class="kit__utils__link font-size-16 mr-3"
                >{{ parseFloat(mad).toFixed(2) }}%</a
              >
              <strong style="font-size: 20px" class="float-right"
                ><sup>{{ record.takenpills }}</sup
                >&frasl;<sub>{{ record.prescription }}</sub></strong
              >
            </div>
            <a-tag color="volcano" v-else><a-icon type="minus"></a-icon></a-tag>
          </template>
          <template slot="januari" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item }}</div>
            </div>
            <!-- {{ record.januariPriceName }} -->
          </template>
          <template slot="februari" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item }}</div>
            </div>
            <!-- {{ record.februariPriceName }} -->
          </template>
          <template slot="maret" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item }}</div>
            </div>
            <!-- {{ record.maretPriceName }} -->
          </template>
          <template slot="april" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item }}</div>
            </div>
            <!-- {{ record.aprilPriceName }} -->
          </template>
          <template slot="mei" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item }}</div>
            </div>
            <!-- {{ record.meiPriceName }} -->
          </template>
          <template slot="juni" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item }}</div>
            </div>
            <!-- {{ record.juniPriceName }} -->
          </template>
          <template slot="juli" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item }}</div>
            </div>
            <!-- {{ record.juliPriceName }} -->
          </template>
          <template slot="agustus" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item }}</div>
            </div>
            <!-- {{ record.agustusPriceName }} -->
          </template>
          <template slot="september" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item }}</div>
            </div>
            <!-- {{ .septemberPriceName }} -->
          </template>
          <template slot="oktober" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item }}</div>
            </div>
            <!-- {{ .oktoberPriceName }} -->
          </template>
          <template slot="november" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item }}</div>
            </div>
            <!-- {{ .novemberPriceName }} -->
          </template>
          <template slot="desember" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">{{ item }}</div>
            </div>
            <!-- {{ .desemberPriceName }} -->
          </template>
        </a-table>
      </a-modal>
      <a-modal
        :footer="null"
        v-model="modalPoDateTable"
        width="100vw"
        @cancel="() => handleCloseModalPoDate()"
      >
        <a-table
          :columns="columnsPoDate"
          :dataSource="selectedPoDateRecord"
          style="margin-top: 15px"
          :pagination="false"
          rowKey="id"
        >
          <template slot="januari" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">Tanggal PO: {{ item.date }}</div>
              <div class="w-100 text-gray-6">
                Tanggal Program: {{ item.createdAtLabel }}
              </div>
              <a-button
                type="primary"
                size="small"
                class="mt-1"
                @click="openPoDateModalFromItem(item)"
                v-if="isAdmin && item.id"
                >{{ item.rawDate ? 'Ubah' : 'Tambah' }}</a-button
              >
            </div>
          </template>
          <template slot="februari" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">Tanggal PO: {{ item.date }}</div>
              <div class="w-100 text-gray-6">
                Tanggal Program: {{ item.createdAtLabel }}
              </div>
              <a-button
                type="primary"
                size="small"
                class="mt-1"
                @click="openPoDateModalFromItem(item)"
                v-if="isAdmin && item.id"
                >{{ item.rawDate ? 'Ubah' : 'Tambah' }}</a-button
              >
            </div>
          </template>
          <template slot="maret" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">Tanggal PO: {{ item.date }}</div>
              <div class="w-100 text-gray-6">
                Tanggal Program: {{ item.createdAtLabel }}
              </div>
              <a-button
                type="primary"
                size="small"
                class="mt-1"
                @click="openPoDateModalFromItem(item)"
                v-if="isAdmin && item.id"
                >{{ item.rawDate ? 'Ubah' : 'Tambah' }}</a-button
              >
            </div>
          </template>
          <template slot="april" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">Tanggal PO: {{ item.date }}</div>
              <div class="w-100 text-gray-6">
                Tanggal Program: {{ item.createdAtLabel }}
              </div>
              <a-button
                type="primary"
                size="small"
                class="mt-1"
                @click="openPoDateModalFromItem(item)"
                v-if="isAdmin && item.id"
                >{{ item.rawDate ? 'Ubah' : 'Tambah' }}</a-button
              >
            </div>
          </template>
          <template slot="mei" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">Tanggal PO: {{ item.date }}</div>
              <div class="w-100 text-gray-6">
                Tanggal Program: {{ item.createdAtLabel }}
              </div>
              <a-button
                type="primary"
                size="small"
                class="mt-1"
                @click="openPoDateModalFromItem(item)"
                v-if="isAdmin && item.id"
                >{{ item.rawDate ? 'Ubah' : 'Tambah' }}</a-button
              >
            </div>
          </template>
          <template slot="juni" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">Tanggal PO: {{ item.date }}</div>
              <div class="w-100 text-gray-6">
                Tanggal Program: {{ item.createdAtLabel }}
              </div>
              <a-button
                type="primary"
                size="small"
                class="mt-1"
                @click="openPoDateModalFromItem(item)"
                v-if="isAdmin && item.id"
                >{{ item.rawDate ? 'Ubah' : 'Tambah' }}</a-button
              >
            </div>
          </template>
          <template slot="juli" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">Tanggal PO: {{ item.date }}</div>
              <div class="w-100 text-gray-6">
                Tanggal Program: {{ item.createdAtLabel }}
              </div>
              <a-button
                type="primary"
                size="small"
                class="mt-1"
                @click="openPoDateModalFromItem(item)"
                v-if="isAdmin && item.id"
                >{{ item.rawDate ? 'Ubah' : 'Tambah' }}</a-button
              >
            </div>
          </template>
          <template slot="agustus" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">Tanggal PO: {{ item.date }}</div>
              <div class="w-100 text-gray-6">
                Tanggal Program: {{ item.createdAtLabel }}
              </div>
              <a-button
                type="primary"
                size="small"
                class="mt-1"
                @click="openPoDateModalFromItem(item)"
                v-if="isAdmin && item.id"
                >{{ item.rawDate ? 'Ubah' : 'Tambah' }}</a-button
              >
            </div>
          </template>
          <template slot="september" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">Tanggal PO: {{ item.date }}</div>
              <div class="w-100 text-gray-6">
                Tanggal Program: {{ item.createdAtLabel }}
              </div>
              <a-button
                type="primary"
                size="small"
                class="mt-1"
                @click="openPoDateModalFromItem(item)"
                v-if="isAdmin && item.id"
                >{{ item.rawDate ? 'Ubah' : 'Tambah' }}</a-button
              >
            </div>
          </template>
          <template slot="oktober" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">Tanggal PO: {{ item.date }}</div>
              <div class="w-100 text-gray-6">
                Tanggal Program: {{ item.createdAtLabel }}
              </div>
              <a-button
                type="primary"
                size="small"
                class="mt-1"
                @click="openPoDateModalFromItem(item)"
                v-if="isAdmin && item.id"
                >{{ item.rawDate ? 'Ubah' : 'Tambah' }}</a-button
              >
            </div>
          </template>
          <template slot="november" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">Tanggal PO: {{ item.date }}</div>
              <div class="w-100 text-gray-6">
                Tanggal Program: {{ item.createdAtLabel }}
              </div>
              <a-button
                type="primary"
                size="small"
                class="mt-1"
                @click="openPoDateModalFromItem(item)"
                v-if="isAdmin && item.id"
                >{{ item.rawDate ? 'Ubah' : 'Tambah' }}</a-button
              >
            </div>
          </template>
          <template slot="desember" slot-scope="text">
            <div
              v-for="(item, index) in text"
              :key="index"
              class="d-flex flex-wrap align-items-center mb-2"
            >
              <div class="w-100">Tanggal PO: {{ item.date }}</div>
              <div class="w-100 text-gray-6">
                Tanggal Program: {{ item.createdAtLabel }}
              </div>
              <a-button
                type="primary"
                size="small"
                class="mt-1"
                @click="openPoDateModalFromItem(item)"
                v-if="isAdmin && item.id"
                >{{ item.rawDate ? 'Ubah' : 'Tambah' }}</a-button
              >
            </div>
          </template>
        </a-table>
      </a-modal>
      <a-modal
        title="Ubah Tanggal PO"
        :visible="visiblePoDateModal"
        @ok="submitPoDate"
        @cancel="
          () => {
            visiblePoDateModal = false
          }
        "
      >
        <div style="margin-bottom: 16px">Silahkan pilih Tanggal PO:</div>
        <a-date-picker
          show-time
          v-model="selectedPoDate"
          format="YYYY-MM-DD HH:mm:ss"
          style="width: 100%"
        />
      </a-modal>
      <a-table
        style="z-index: 1"
        :columns="columns"
        :dataSource="filteredData"
        :pagination="pagination"
        :class="$style.table"
        rowKey="id"
        :loading="isLoading"
        @change="onChangeTable"
      >
        <template slot="code" slot-scope="code, record">
          <div>
            <div v-if="isAdmin">
              <div v-if="record.program && record.program.checkPoint >= 5">
                <router-link
                  :to="{ path: '/pasien/details/' + code }"
                  class="kit__utils__link font-size-16"
                  >{{ code ? code : '-' }}</router-link
                >
              </div>
              <div v-else>
                <router-link
                  :to="{ path: '/pasien/program/tambah/' + code }"
                  class="kit__utils__link font-size-16"
                  >{{ code ? code : '-' }}</router-link
                >
              </div>
            </div>
            <div v-if="!isAdmin">
              <!-- <div v-if="record.program && record.program.checkPoint >= 5">
                <router-link
                  :to="{ path: '/pasien/details/' + code }"
                  class="kit__utils__link font-size-16"
                  >{{ code ? code : '-' }}</router-link
                >
              </div> -->
              <div>
                {{ code ? code : '-' }}
              </div>
            </div>
            <div class="text-gray-4">{{ record.city ? record.city : '-' }}</div>
          </div>
        </template>
        <template slot="category" slot-scope="category">
          {{ category ? category.toUpperCase() : 'PULIH' }}
          <!-- {{ JSON.stringify(record, null, 2) }} -->
        </template>
        <template slot="createdAt" slot-scope="createdAt, record">
          <div>
            {{ record.programs.length ? handleMakeFirstProgram(record) : '-' }}
          </div>
        </template>
        <template slot="enrollDate" slot-scope="enrollDate">
          <div>
            <div>
              {{
                enrollDate
                  ? moment(enrollDate).format('DD MMM YYYY HH:mm:ss')
                  : '-'
              }}
            </div>
          </div>
        </template>
        <template slot="extendDate" slot-scope="extendDate, record">
          <div>
            {{
              extendDate
                ? moment(extendDate).format('DD MMM YYYY HH:mm:ss')
                : '-'
            }}
          </div>
          <a-select
            style="
              width: 180px;
              z-index: 99;
              border: 1px solid black;
              border-radius: 4px;
            "
            v-model="selectedPerpanjangYearRecord[`${record.id}`]"
            @change="(val) => onYearPerpanjangChanged(val, record)"
            @dropdownVisibleChange="
              (open) => {
                getYearPerpanjang(record, open)
              }
            "
          >
            <a-select-option
              v-for="(year, i) in selectedPerpanjangYearRow"
              :label="year"
              :key="i"
              :value="year"
            >
              {{ year }}
            </a-select-option>
          </a-select>
        </template>
        <template slot="resultSurvey" slot-scope="resultSurvey">
          <!-- <p>{{ JSON.stringify(resultSurvey) }}</p> -->
          <template v-if="resultSurvey.length">
            <a-tag class="my-1" v-if="resultSurvey[0].response">{{
              resultSurvey[0].response
            }}</a-tag>
            <a-tag class="my-1" v-else>{{
              resultSurvey[0].result.result
            }}</a-tag>
          </template>
          <div v-else>-</div>
        </template>
        <template slot="terminatedDate" slot-scope="terminatedDate">
          <div>
            <div>
              {{
                terminatedDate
                  ? moment(terminatedDate).format('DD MMM YYYY')
                  : '-'
              }}
            </div>
          </div>
        </template>
        <template slot="city" slot-scope="city">
          <div>
            <div>{{ city ? city : '-' }}</div>
          </div>
        </template>
        <template slot="doctor" slot-scope="doctor, record">
          <div v-if="record.program">
            <div>
              {{ record.program ? record.program.doctor.fullname : '-' }}
            </div>
            <div class="text-gray-4">
              {{ record.program.doctor ? record.program.doctor.hospital : '-' }}
            </div>
          </div>
          <div v-else>{{ '-' }}</div>
        </template>
        <template slot="programType" slot-scope="programType, record">
          <div>
            <div>
              {{ record.program ? record.program.programType.name : '-' }}
            </div>
            <!-- <div class="text-gray-4">
              {{ record.program.doctor ? record.program.doctor.hospital : '-' }}
            </div> -->
          </div>
        </template>
        <template slot="pharmacy" slot-scope="pharmacy">
          <div>
            <div>{{ pharmacy ? pharmacy.name : '-' }}</div>
          </div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="row">
            <a-popover class="col mb-2">
              <span
                slot="content"
                class="kit__utils__link font-size-16 text-success"
                >Download</span
              >
              <button
                @click="downloadData(record)"
                type="button"
                class="btn btn-outline-warning"
              >
                <i class="fa fa-download"></i>
              </button>
            </a-popover>
            <a-popover class="col">
              <span
                slot="content"
                class="kit__utils__link font-size-16 text-success"
                >Kirim Email</span
              >
              <button
                @click="email(record)"
                type="button"
                class="btn btn-outline-success"
              >
                <i class="far fa-envelope"></i>
              </button>
            </a-popover>
          </div>
        </template>
        <template slot="redemp" slot-scope="redemp, record">
          <div>
            {{ record.programs.length ? handleMakeLastProgram(record) : '-' }}
          </div>
          <a-select
            style="
              width: 180px;
              z-index: 99;
              border: 1px solid black;
              border-radius: 4px;
            "
            v-model="selectedRedemptionYearRecord[`${record.id}`]"
            @change="(val) => onYearRedemptionChanged(val, record)"
            @dropdownVisibleChange="
              (open) => {
                getYearRedemption(record, open)
              }
            "
          >
            <a-select-option
              v-for="(year, i) in selectedRedemptionYearRow"
              :label="year"
              :key="i"
              :value="year"
            >
              {{ year }}
            </a-select-option>
          </a-select>
        </template>
        <template slot="verifDate" slot-scope="verifDate, record">
          <div>
            {{
              verifDate ? moment(verifDate).format('DD MMM YYYY HH:mm:ss') : '-'
            }}
          </div>
          <a-select
            style="
              width: 180px;
              z-index: 99;
              border: 1px solid black;
              border-radius: 4px;
            "
            v-model="selectedVerifYearRecord[`${record.id}`]"
            @change="(val) => onYearVerifChanged(val, record)"
            @dropdownVisibleChange="
              (open) => {
                getYearVerif(record, open)
              }
            "
          >
            <a-select-option
              v-for="(year, i) in selectedVerifYearRow"
              :label="year"
              :key="i"
              :value="year"
            >
              {{ year }}
            </a-select-option>
          </a-select>
        </template>
        <template slot="poDateGroup" slot-scope="poDateGroup, record">
          <a-select
            style="
              width: 180px;
              z-index: 99;
              border: 1px solid black;
              border-radius: 4px;
              margin-bottom: 8px;
            "
            v-model="selectedPoDateYearRecord[`${record.id}`]"
            @change="(val) => onYearPoDateChanged(val, record)"
            @dropdownVisibleChange="
              (open) => {
                getYearPoDate(record, open)
              }
            "
          >
            <a-select-option
              v-for="(year, i) in selectedPoDateYearRow"
              :label="year"
              :key="i"
              :value="year"
            >
              {{ year }}
            </a-select-option>
          </a-select>
          <div>
            <a-button
              v-if="!record.program || !record.program.poDate"
              type="primary"
              size="small"
              @click="openPoDateModal(record)"
            >
              Tambah PO
            </a-button>
            <a-button
              v-else
              disabled
              size="small"
              class="bg-transparent text-gray-6"
            >
              {{ moment(record.program.poDate).format('DD MMM YYYY HH:mm:ss') }}
            </a-button>
          </div>
        </template>
        <template slot="isTerminated" slot-scope="isTerminated, record">
          <a-tag
            :color="
              getStatus(isTerminated, record) === 'Berhenti'
                ? 'volcano'
                : getStatus(isTerminated, record) === 'Tidak Aktif'
                ? 'orange'
                : getStatus(isTerminated, record) === 'Pasien Baru'
                ? 'green'
                : getStatus(isTerminated, record) === 'Belum Scan QR'
                ? 'orange'
                : getStatus(isTerminated, record) === 'Belum Terdaftar'
                ? 'orange'
                : getStatus(isTerminated, record) === 'Perpanjang'
                ? 'blue'
                : 'lightgrey'
            "
          >
            {{ getStatus(isTerminated, record) }}
          </a-tag>
        </template>
      </a-table>
      <!-- Total DOT Pasien : <strong>{{ totalDoT }}</strong> <br />
      Mean DOT Pasien : <strong>{{ meanDoT }}</strong> <br />
      Median DOT Pasien : <strong>{{ medianDoT }}</strong> -->
    </div>
  </div>
</template>
<script>
import HtmlTableToJson from 'html-table-to-json'
import XLSX from 'xlsx'
import data from './data.json'
// import { getAllPatientData, bulkGetByCode } from '@/services/axios/api/pasien'
import {
  // getAllPatientData,
  bulkCreate,
  sendEmail,
  // getRedemptionByCode,
} from '@/services/axios/api/pasien'
import {
  // listAllTakenPills,
  listAllPillsStatus,
} from '@/services/axios/api/pillsTaken'
import moment from 'moment'
import router from '@/router'
// import fuzzysort from 'fuzzysort'
import { mapGetters } from 'vuex'
import apiClient from '../../../services/axios'
// import store from 'store'
import { getProgramTypeAll } from '@/services/axios/api/program'
const columns = [
  {
    title: 'Data Utama',
    className: 'border bg-transparent text-gray-6',
    children: [
      {
        title: 'Pasien',
        dataIndex: 'code',
        className: 'bg-transparent border-left text-gray-6 width-50',
        scopedSlots: { customRender: 'code' },
        fixed: 'left',
        sorter: (a, b) => {
          return a.code.localeCompare(b.code)
        },
        filters: [],
        // onFilter: (value, record) => {
        //   return record.city === value
        // },
      },
      {
        title: 'Tanggal Program Pertama',
        className: 'bg-transparent text-gray-6',
        scopedSlots: { customRender: 'createdAt' },
        fixed: 'left',
        filters: [],
        // sorter: (a, b) => a.mad - b.mad,
        // onFilter: (value, record) => {
        //   return record.city === value
        // },
      },

      {
        title: 'Tanggal Enrollment',
        dataIndex: 'program.createdAt',
        className: 'bg-transparent text-gray-6',
        scopedSlots: { customRender: 'extendDate' },
        sorter: (a, b) => {
          if (!a.program) {
            return -1
          } else if (!b.program) {
            return 1
          } else if (!a.program.createdAt) {
            return -1
          } else if (!b.program.createdAt) {
            return 1
          } else {
            return a.program.createdAt.localeCompare(b.program.createdAt)
          }
        },
      },
      {
        title: 'Tanggal Verifikasi',
        dataIndex: 'program.enrollDate',
        className: 'bg-transparent text-gray-6',
        scopedSlots: { customRender: 'verifDate' },
        sorter: (a, b) => {
          if (!a.program) {
            return -1
          } else if (!b.program) {
            return 1
          } else if (!a.program.drugsTakenDate) {
            return -1
          } else if (!b.program.drugsTakenDate) {
            return 1
          } else {
            return a.program.drugsTakenDate.localeCompare(
              b.program.drugsTakenDate,
            )
          }
        },
      },
      {
        title: 'Tanggal Redemption',
        dataIndex: 'redemp',
        className: 'bg-transparent text-gray-6',
        scopedSlots: { customRender: 'redemp' },
        fixed: 'left',
        filters: [],
        // sorter: (a, b) => a.mad - b.mad,
        // onFilter: (value, record) => {
        //   return record.city === value
        // },
      },
      {
        title: 'Tanggal PO',
        dataIndex: 'program.poDate',
        className: 'bg-transparent text-gray-6',
        scopedSlots: { customRender: 'poDateGroup' },
      },
      {
        title: 'Dokter',
        dataIndex: 'doctor',
        className: 'bg-transparent',
        scopedSlots: { customRender: 'doctor' },
        sorter: (a, b) => {
          if (!a.program) {
            return -1
          } else if (!b.program) {
            return 1
          } else {
            return a.doctor.fullname.localeCompare(b.doctor.fullname)
          }
        },
        filters: [],
        // onFilter: (value, record) => {
        //   return record.doctor ? record.doctor.fullname === value : -1
        // },
      },
      {
        title: 'Farmasi',
        dataIndex: 'program.pharmacy',
        className: 'bg-transparent',
        scopedSlots: { customRender: 'pharmacy' },
        sorter: (a, b) => {
          if (!a.program) {
            return -1
          } else if (!b.program) {
            return 1
          } else if (!a.program.pharmacy) {
            return -1
          } else if (!b.program.pharmacy) {
            return 1
          } else {
            return a.program.pharmacy.name.localeCompare(
              b.program.pharmacy.name,
            )
          }
        },
        filters: [],
        // onFilter: (value, record) => {
        //   return record.pharmacy ? record.pharmacy.name === value : -1
        // },
      },
      {
        title: 'Status',
        dataIndex: 'program.isTerminated',
        className: 'bg-transparent',
        scopedSlots: { customRender: 'isTerminated' },
      },
      {
        title: 'Program',
        dataIndex: 'programType',
        className: 'bg-transparent',
        // filters: [
        //   {
        //     text: 'TAGRISSO',
        //     value: 'TAGRISSO',
        //   },
        //   {
        //     text: 'FASLODEX',
        //     value: 'FASLODEX',
        //   },
        //   {
        //     text: 'LYNPARZA',
        //     value: 'LYNPARZA',
        //   },
        //   {
        //     text: 'IMFINZI',
        //     value: 'IMFINZI',
        //   },
        //   {
        //     text: 'ENHERTU',
        //     value: 'ENHERTU',
        //   },
        //   {
        //     text: 'IMJUDO',
        //     value: 'IMJUDO',
        //   },
        //   {
        //     text: 'CALQUENCE',
        //     value: 'CALQUENCE',
        //   },
        // ],
        // onFilter: (value, record) => {
        //   return record.programType === value
        // },
        scopedSlots: { customRender: 'programType' },
      },
      {
        title: 'Category',
        dataIndex: 'program.category',
        className: 'bg-transparent',
        // filters: [
        //   {
        //     text: 'TAGRISSO',
        //     value: 'TAGRISSO',
        //   },
        //   {
        //     text: 'FASLODEX',
        //     value: 'FASLODEX',
        //   },
        //   {
        //     text: 'LYNPARZA',
        //     value: 'LYNPARZA',
        //   },
        //   {
        //     text: 'IMFINZI',
        //     value: 'IMFINZI',
        //   },
        //   {
        //     text: 'ENHERTU',
        //     value: 'ENHERTU',
        //   },
        //   {
        //     text: 'IMJUDO',
        //     value: 'IMJUDO',
        //   },
        //   {
        //     text: 'CALQUENCE',
        //     value: 'CALQUENCE',
        //   },
        // ],
        // onFilter: (value, record) => {
        //   return record.programType === value
        // },
        scopedSlots: { customRender: 'category' },
      },
      {
        title: 'Hasil Survey',
        dataIndex: 'resultSurvey',
        className: 'bg-transparent',
        scopedSlots: { customRender: 'resultSurvey' },
      },
      {
        title: 'Action',
        dataIndex: 'action',
        className: 'bg-transparent',
        scopedSlots: { customRender: 'action' },
      },
    ],
  },
]
const columnsRedemption = [
  {
    title: 'Tanggal Redemption',
    className: 'border bg-transparent text-gray-6',
    scopedSlots: { customRender: 'redemption' },
    children: [
      {
        title: 'Januari',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'januari' },
        sorter: (a, b) => a.januari.length - b.januari.length,
        dataIndex: 'januari',
      },
      {
        title: 'Februari',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'februari' },
        dataIndex: 'februari',
        sorter: (a, b) => a.februari.length - b.februari.length,
      },
      {
        title: 'Maret',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'maret' },
        dataIndex: 'maret',
        sorter: (a, b) => a.maret.length - b.maret.length,
      },
      {
        title: 'April',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'april' },
        dataIndex: 'april',
        sorter: (a, b) => a.april.length - b.april.length,
      },
      {
        title: 'Mei',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'mei' },
        dataIndex: 'mei',
        sorter: (a, b) => a.mei.length - b.mei.length,
      },
      {
        title: 'Juni',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'juni' },
        dataIndex: 'juni',
        sorter: (a, b) => a.juni.length - b.juni.length,
      },
      {
        title: 'Juli',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'juli' },
        dataIndex: 'juli',
        sorter: (a, b) => a.juli.length - b.juli.length,
      },
      {
        title: 'Agustus',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'agustus' },
        dataIndex: 'agustus',
        sorter: (a, b) => a.agustus.length - b.agustus.length,
      },
      {
        title: 'September',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'september' },
        dataIndex: 'september',
        sorter: (a, b) => a.september.length - b.september.length,
      },
      {
        title: 'Oktober',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'oktober' },
        dataIndex: 'oktober',
        sorter: (a, b) => a.oktober.length - b.oktober.length,
      },
      {
        title: 'November',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'november' },
        dataIndex: 'november',
        sorter: (a, b) => a.november.length - b.november.length,
      },
      {
        title: 'Desember',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'desember' },
        dataIndex: 'desember',
        sorter: (a, b) => a.desember.length - b.desember.length,
      },
    ],
  },
]
const columnsVerif = [
  {
    title: 'Tanggal Verifikasi',
    className: 'border bg-transparent text-gray-6',
    scopedSlots: { customRender: 'verif' },
    children: [
      {
        title: 'Januari',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'januari' },
        sorter: (a, b) => a.januari.length - b.januari.length,
        dataIndex: 'januariVerif',
      },
      {
        title: 'Februari',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'februari' },
        dataIndex: 'februariVerif',
        sorter: (a, b) => a.februari.length - b.februari.length,
      },
      {
        title: 'Maret',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'maret' },
        dataIndex: 'maretVerif',
        sorter: (a, b) => a.maret.length - b.maret.length,
      },
      {
        title: 'April',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'april' },
        dataIndex: 'aprilVerif',
        sorter: (a, b) => a.april.length - b.april.length,
      },
      {
        title: 'Mei',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'mei' },
        dataIndex: 'meiVerif',
        sorter: (a, b) => a.mei.length - b.mei.length,
      },
      {
        title: 'Juni',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'juni' },
        dataIndex: 'juniVerif',
        sorter: (a, b) => a.juni.length - b.juni.length,
      },
      {
        title: 'Juli',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'juli' },
        dataIndex: 'juliVerif',
        sorter: (a, b) => a.juli.length - b.juli.length,
      },
      {
        title: 'Agustus',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'agustus' },
        dataIndex: 'agustusVerif',
        sorter: (a, b) => a.agustus.length - b.agustus.length,
      },
      {
        title: 'September',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'september' },
        dataIndex: 'septemberVerif',
        sorter: (a, b) => a.september.length - b.september.length,
      },
      {
        title: 'Oktober',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'oktober' },
        dataIndex: 'oktoberVerif',
        sorter: (a, b) => a.oktober.length - b.oktober.length,
      },
      {
        title: 'November',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'november' },
        dataIndex: 'novemberVerif',
        sorter: (a, b) => a.november.length - b.november.length,
      },
      {
        title: 'Desember',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'desember' },
        dataIndex: 'desemberVerif',
        sorter: (a, b) => a.desember.length - b.desember.length,
      },
    ],
  },
]
const columnsPoDate = [
  {
    title: 'Tanggal PO',
    className: 'border bg-transparent text-gray-6',
    scopedSlots: { customRender: 'poDateGroup' },
    children: [
      {
        title: 'Januari',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'januari' },
        sorter: (a, b) => a.januari.length - b.januari.length,
        dataIndex: 'januariPoDate',
      },
      {
        title: 'Februari',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'februari' },
        dataIndex: 'februariPoDate',
        sorter: (a, b) => a.februari.length - b.februari.length,
      },
      {
        title: 'Maret',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'maret' },
        dataIndex: 'maretPoDate',
        sorter: (a, b) => a.maret.length - b.maret.length,
      },
      {
        title: 'April',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'april' },
        dataIndex: 'aprilPoDate',
        sorter: (a, b) => a.april.length - b.april.length,
      },
      {
        title: 'Mei',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'mei' },
        dataIndex: 'meiPoDate',
        sorter: (a, b) => a.mei.length - b.mei.length,
      },
      {
        title: 'Juni',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'juni' },
        dataIndex: 'juniPoDate',
        sorter: (a, b) => a.juni.length - b.juni.length,
      },
      {
        title: 'Juli',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'juli' },
        dataIndex: 'juliPoDate',
        sorter: (a, b) => a.juli.length - b.juli.length,
      },
      {
        title: 'Agustus',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'agustus' },
        dataIndex: 'agustusPoDate',
        sorter: (a, b) => a.agustus.length - b.agustus.length,
      },
      {
        title: 'September',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'september' },
        dataIndex: 'septemberPoDate',
        sorter: (a, b) => a.september.length - b.september.length,
      },
      {
        title: 'Oktober',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'oktober' },
        dataIndex: 'oktoberPoDate',
        sorter: (a, b) => a.oktober.length - b.oktober.length,
      },
      {
        title: 'November',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'november' },
        dataIndex: 'novemberPoDate',
        sorter: (a, b) => a.november.length - b.november.length,
      },
      {
        title: 'Desember',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'desember' },
        dataIndex: 'desemberPoDate',
        sorter: (a, b) => a.desember.length - b.desember.length,
      },
    ],
  },
]
const columnsPerpanjang = [
  {
    title: 'Tanggal Perpanjang',
    className: 'border bg-transparent text-gray-6',
    scopedSlots: { customRender: 'perpanjang' },
    children: [
      {
        title: 'Januari',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'januari' },
        sorter: (a, b) => a.januari.length - b.januari.length,
        dataIndex: 'januariPerpanjang',
      },
      {
        title: 'Februari',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'februari' },
        dataIndex: 'februariPerpanjang',
        sorter: (a, b) => a.februari.length - b.februari.length,
      },
      {
        title: 'Maret',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'maret' },
        dataIndex: 'maretPerpanjang',
        sorter: (a, b) => a.maret.length - b.maret.length,
      },
      {
        title: 'April',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'april' },
        dataIndex: 'aprilPerpanjang',
        sorter: (a, b) => a.april.length - b.april.length,
      },
      {
        title: 'Mei',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'mei' },
        dataIndex: 'meiPerpanjang',
        sorter: (a, b) => a.mei.length - b.mei.length,
      },
      {
        title: 'Juni',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'juni' },
        dataIndex: 'juniPerpanjang',
        sorter: (a, b) => a.juni.length - b.juni.length,
      },
      {
        title: 'Juli',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'juli' },
        dataIndex: 'juliPerpanjang',
        sorter: (a, b) => a.juli.length - b.juli.length,
      },
      {
        title: 'Agustus',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'agustus' },
        dataIndex: 'agustusPerpanjang',
        sorter: (a, b) => a.agustus.length - b.agustus.length,
      },
      {
        title: 'September',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'september' },
        dataIndex: 'septemberPerpanjang',
        sorter: (a, b) => a.september.length - b.september.length,
      },
      {
        title: 'Oktober',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'oktober' },
        dataIndex: 'oktoberPerpanjang',
        sorter: (a, b) => a.oktober.length - b.oktober.length,
      },
      {
        title: 'November',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'november' },
        dataIndex: 'novemberPerpanjang',
        sorter: (a, b) => a.november.length - b.november.length,
      },
      {
        title: 'Desember',
        className: 'border bg-transparent text-gray-6',
        scopedSlots: { customRender: 'desember' },
        dataIndex: 'desemberPerpanjang',
        sorter: (a, b) => a.desember.length - b.desember.length,
      },
    ],
  },
]
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export default {
  name: 'TabelPasien',
  data() {
    return {
      columns,
      columnsRedemption,
      columnsVerif,
      columnsPerpanjang,
      columnsPoDate,
      data,
      visible: false,
      months: [
        'januari',
        'februari',
        'maret',
        'april',
        'mei',
        'juni',
        'juli',
        'agustus',
        'september',
        'oktober',
        'november',
        'desember',
      ],
      year: String(new Date().getFullYear()),
      month: [],
      poDateMonth: undefined,
      yearRedemption: '',
      items: [],
      selectedDoctorFilter: [],
      selectedCityFilter: [],
      selectedPharmacyFilters: [],
      selectedStatusFilters: '',
      selectedDeathCauseFilters: [],
      cityFilters: [],
      doctorFilters: [],
      pharmacyFilters: [],
      statusFilters: [],
      deathCauseFilters: [],
      totalDoT: 0,
      meanDoT: 0,
      medianDoT: 0,
      isLoading: true,
      pills: [],
      isAdmin: false,
      dataLen: 0,
      filtered: [],
      count: 0,
      cancelToken: '',
      patientRequestId: 0,
      selectedRedemptionRecord: [],
      selectedRedemptionYearRow: [],
      selectedVerifRecord: [],
      selectedVerifYearRow: [],
      selectedPerpanjangRecord: [],
      selectedPerpanjangYearRow: [],
      programsRedemption: [],
      modalRedemption: false,
      modalVerif: false,
      modalPerpanjang: false,
      testingData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      programTypeItems: [],
      pharmacyItems: [],
      filterProgram: 'Semua',
      filterBycode: null,
      selectedRedemptionYearRecord: {},
      selectedVerifYearRecord: {},
      selectedPerpanjangYearRecord: {},
      selectedPoDateYearRow: [],
      selectedPoDateYearRecord: {},
      selectedPoDateRecord: [],
      modalPoDateTable: false,
      visiblePoDateModal: false,
      selectedPoDate: null,
      selectedPoRecord: null,
      capitalizeFirstLetter,
    }
  },
  computed: {
    availableYears() {
      const curYear = new Date().getFullYear()
      const years = []
      for (let y = 2017; y <= curYear; y++) {
        years.push(String(y))
      }
      return years.reverse()
    },
    filteredData: {
      get() {
        return this.filtered
      },
      set(newValue) {
        this.filtered = newValue
      },
    },
    ...mapGetters('user', ['user']),
  },
  created() {
    this.getAllPatient()
    this.getProgramTypeAll()
    this.getPharmacyAll()
    this.getRole()
  },
  methods: {
    moment,
    openPoDateModalFromItem(item) {
      if (!item || !item.id) {
        this.$notification.warning({
          message: 'Peringatan',
          description: 'Data program tidak valid!',
        })
        return
      }
      this.selectedPoRecord = { program: { id: item.id } }
      this.selectedPoDate = item.rawDate ? moment(item.rawDate) : null
      this.visiblePoDateModal = true
    },
    async getYearPoDate(record, open) {
      if (open) {
        const programsPoDate = record.programs
        for (const key in programsPoDate) {
          const pro = programsPoDate[key]
          if (!pro.createdAt) {
            continue
          }
          const comparison = moment(pro.createdAt).year()
          if (!Number.isFinite(comparison)) {
            continue
          }

          if (Number(this.year) === comparison) {
            if (!this.selectedPoDateYearRow.includes(comparison)) {
              this.selectedPoDateYearRow.push(comparison)
            }
            break
          }
          if (!this.year) {
            if (!this.selectedPoDateYearRow.includes(comparison)) {
              this.selectedPoDateYearRow.push(comparison)
            }
          }
        }
        this.selectedPoDateYearRow.sort()
      } else {
        this.selectedPoDateYearRow = []
      }
    },
    openPoDateModal(record) {
      if (!record || !record.program || !record.program.id) {
        this.$notification.warning({
          message: 'Peringatan',
          description: 'Data program tidak valid!',
        })
        return
      }
      this.selectedPoRecord = record
      this.selectedPoDate = record.program.poDate
        ? moment(record.program.poDate)
        : null
      this.visiblePoDateModal = true
    },
    async submitPoDate() {
      if (
        !this.selectedPoRecord ||
        !this.selectedPoRecord.program ||
        !this.selectedPoDate
      ) {
        this.$notification.warning({
          message: 'Peringatan',
          description: 'Pilih data dan tanggal yang valid!',
        })
        return
      }

      const poDateStr = this.selectedPoDate.format('YYYY-MM-DD HH:mm:ss')

      try {
        const { updatePoDate } = await import('@/services/axios/api/program')
        const response = await updatePoDate(this.selectedPoRecord.program.id, {
          poDate: poDateStr,
        })

        if (response && response.status === 200) {
          this.$notification.success({
            message: 'Sukses',
            description: 'Tanggal PO berhasil diperbarui!',
          })
          this.visiblePoDateModal = false
          // Refresh data
          this.getAllPatient(this.filterProgram)
        } else {
          throw new Error('Update failed')
        }
      } catch (error) {
        this.$notification.error({
          message: 'Gagal',
          description: 'Gagal memperbarui Tanggal PO',
        })
      }
    },
    async getYearRedemption(record, open) {
      // this.redemptionLoading = true

      if (open) {
        const programsRedemption = record.programs
        for (const key in programsRedemption) {
          const pro = programsRedemption[key]
          const comparison = moment(pro.red).year()

          if (Number(this.year) === comparison) {
            if (!this.selectedRedemptionYearRow.includes(comparison)) {
              // cityFilters.push(user.city)
              this.selectedRedemptionYearRow.push(comparison)
            }
            break
          }
          if (!this.year) {
            if (pro.red) {
              if (!this.selectedRedemptionYearRow.includes(comparison)) {
                // cityFilters.push(user.city)
                this.selectedRedemptionYearRow.push(comparison)
              }
            }
          }
        }
        this.selectedRedemptionYearRow.sort()
      } else {
        this.selectedRedemptionYearRow = []
      }
    },
    async getYearVerif(record, open) {
      // this.redemptionLoading = true

      if (open) {
        const programsRedemption = record.programs
        for (const key in programsRedemption) {
          const pro = programsRedemption[key]
          const comparison = moment(pro.enrollDate).year()
          //
          if (Number(this.year) === comparison) {
            if (!this.selectedVerifYearRow.includes(comparison)) {
              // cityFilters.push(user.city)
              this.selectedVerifYearRow.push(comparison)
            }
            break
          }
          if (!this.year) {
            if (pro.enrollDate) {
              if (!this.selectedVerifYearRow.includes(comparison)) {
                // cityFilters.push(user.city)
                this.selectedVerifYearRow.push(comparison)
              }
            }
          }
        }
        this.selectedVerifYearRow.sort()
      } else {
        this.selectedVerifYearRow = []
      }
    },
    async getYearPerpanjang(record, open) {
      // this.redemptionLoading = true

      if (open) {
        const programsPerpanjang = record.programs
        for (const key in programsPerpanjang) {
          const pro = programsPerpanjang[key]
          const comparison = moment(pro.createdAt).year()
          //
          if (Number(this.year) === comparison) {
            if (!this.selectedPerpanjangYearRow.includes(comparison)) {
              // cityFilters.push(user.city)
              this.selectedPerpanjangYearRow.push(comparison)
            }
            break
          }
          if (!this.year) {
            if (pro.createdAt) {
              if (!this.selectedPerpanjangYearRow.includes(comparison)) {
                // cityFilters.push(user.city)
                this.selectedPerpanjangYearRow.push(comparison)
              }
            }
          }
        }
        this.selectedPerpanjangYearRow.sort()
      } else {
        this.selectedPerpanjangYearRow = []
      }
    },
    showModal(record) {
      this.listPillsTaken(record)
      this.visible = true
    },
    handleShowModalRedemption(record) {
      this.selectedRedemptionRecord = [record]
      this.modalRedemption = true
    },
    handleShowModalVerif(record) {
      this.selectedVerifRecord = [record]
      this.modalVerif = true
    },
    handleShowModalPerpanjang(record) {
      this.selectedPerpanjangRecord = [record]
      this.modalPerpanjang = true
    },
    handleCloseModalRedemp() {
      this.selectedRedemptionYearRecord[
        this.selectedRedemptionRecord[0].id
      ] = null
      this.selectedRedemptionRecord = []
      this.modalRedemption = false
    },
    handleCloseModalVerif() {
      this.selectedVerifYearRecord[this.selectedVerifRecord[0].id] = null
      this.selectedVerifRecord = []
      this.modalVerif = false
    },
    handleCloseModalPerpanjang() {
      this.selectedPerpanjangYearRecord[
        this.selectedPerpanjangRecord[0].id
      ] = null
      this.selectedPerpanjangRecord = []
      this.modalPerpanjang = false
    },
    handleShowModalPoDate(record) {
      this.selectedPoDateRecord = [record]
      this.modalPoDateTable = true
    },
    handleCloseModalPoDate() {
      this.selectedPoDateYearRecord[this.selectedPoDateRecord[0].id] = null
      this.selectedPoDateRecord = []
      this.modalPoDateTable = false
    },
    async email(record) {
      //
      const res = await sendEmail(record.email)
      //
      if (res.data) {
        this.$notification.success({
          message: 'Berhasil',
          description: res.data.data,
          duration: 5,
        })
      }
    },
    onYearChanged(val) {
      if (!val) {
        this.month = []
      }
      this.year = val
      this.pagination.current = 1
      this.totalDoT = 0
      this.meanDoT = 0
      this.medianDoT = 0
      this.getAllPatient()
    },
    onPoDateMonthChanged(val) {
      this.poDateMonth = val
      this.pagination.current = 1
      this.getAllPatient(this.filterProgram)
    },
    onMonthChanged(val) {
      this.month = val
      this.pagination.current = 1
      this.totalDoT = 0
      this.meanDoT = 0
      this.medianDoT = 0
      this.getAllPatient()
    },
    onYearRedemptionChanged(val, record) {
      if (val) {
        const user = this.listRedemptionDatesModal(record, val)
        this.handleShowModalRedemption(user)
      }
    },
    onYearVerifChanged(val, record) {
      if (val) {
        const user = this.listVerifDatesModal(record, val)
        this.handleShowModalVerif(user)
      }
    },
    onYearPerpanjangChanged(val, record) {
      if (val) {
        const user = this.listPerpanjangDatesModal(record, val)
        this.handleShowModalPerpanjang(user)
      }
    },
    onYearPoDateChanged(val, record) {
      if (val) {
        const user = this.listPoDateDatesModal(record, val)
        this.handleShowModalPoDate(user)
      }
    },
    listVerifDatesModal(user, year) {
      user.januariVerif = []
      user.februariVerif = []
      user.maretVerif = []
      user.aprilVerif = []
      user.meiVerif = []
      user.juniVerif = []
      user.juliVerif = []
      user.agustusVerif = []
      user.septemberVerif = []
      user.oktoberVerif = []
      user.novemberVerif = []
      user.desemberVerif = []

      for (const j of user.programs) {
        const verifDate = j.enrollDate
        if (this.isInMonth(verifDate, Number(year), 0)) {
          user.januariVerif.push({
            date: verifDate
              ? moment(verifDate).format('DD-MMM-YYYY HH:mm:ss')
              : '-',
            price: j.price.name || '-',
          })
        }
        if (this.isInMonth(verifDate, Number(year), 1)) {
          user.februariVerif.push({
            date: verifDate
              ? moment(verifDate).format('DD-MMM-YYYY HH:mm:ss')
              : '-',
            price: j.price.name || '-',
          })
        }
        if (this.isInMonth(verifDate, Number(year), 2)) {
          user.maretVerif.push({
            date: verifDate
              ? moment(verifDate).format('DD-MMM-YYYY HH:mm:ss')
              : '-',
            price: j.price.name || '-',
          })
        }
        if (this.isInMonth(verifDate, Number(year), 3)) {
          user.aprilVerif.push({
            date: verifDate
              ? moment(verifDate).format('DD-MMM-YYYY HH:mm:ss')
              : '-',
            price: j.price.name || '-',
          })
        }
        if (this.isInMonth(verifDate, Number(year), 4)) {
          user.meiVerif.push({
            date: verifDate
              ? moment(verifDate).format('DD-MMM-YYYY HH:mm:ss')
              : '-',
            price: j.price.name || '-',
          })
        }
        if (this.isInMonth(verifDate, Number(year), 5)) {
          user.juniVerif.push({
            date: verifDate
              ? moment(verifDate).format('DD-MMM-YYYY HH:mm:ss')
              : '-',
            price: j.price.name || '-',
          })
        }
        if (this.isInMonth(verifDate, Number(year), 6)) {
          user.juliVerif.push({
            date: verifDate
              ? moment(verifDate).format('DD-MMM-YYYY HH:mm:ss')
              : '-',
            price: j.price.name || '-',
          })
        }
        if (this.isInMonth(verifDate, Number(year), 7)) {
          user.agustusVerif.push({
            date: verifDate
              ? moment(verifDate).format('DD-MMM-YYYY HH:mm:ss')
              : '-',
            price: j.price.name || '-',
          })
        }
        if (this.isInMonth(verifDate, Number(year), 8)) {
          user.septemberVerif.push({
            date: verifDate
              ? moment(verifDate).format('DD-MMM-YYYY HH:mm:ss')
              : '-',
            price: j.price.name || '-',
          })
        }
        if (this.isInMonth(verifDate, Number(year), 9)) {
          user.oktoberVerif.push({
            date: verifDate
              ? moment(verifDate).format('DD-MMM-YYYY HH:mm:ss')
              : '-',
            price: j.price.name || '-',
          })
        }
        if (this.isInMonth(verifDate, Number(year), 10)) {
          user.novemberVerif.push({
            date: verifDate
              ? moment(verifDate).format('DD-MMM-YYYY HH:mm:ss')
              : '-',
            price: j.price.name || '-',
          })
        }
        if (this.isInMonth(verifDate, Number(year), 11)) {
          user.desemberVerif.push({
            date: verifDate
              ? moment(verifDate).format('DD-MMM-YYYY HH:mm:ss')
              : '-',
            price: j.price.name || '-',
          })
        }
      }
      return user
    },
    listPerpanjangDatesModal(user, year) {
      const seeders = this.insertByMonth(user, 'Perpanjang', 'createdAt', year)
      const months = [
        'januari',
        'februari',
        'maret',
        'april',
        'mei',
        'juni',
        'juli',
        'agustus',
        'september',
        'oktober',
        'november',
        'desember',
      ]
      months.forEach((m) => {
        const k = m + 'Perpanjang'
        const hit = seeders.filter(
          (r) => r[k] && r[k] !== '-' && r.checkPoint !== 1,
        )
        user[k] = hit ? hit.map((e) => e[k]) : '-'
      })

      return user
    },
    listPoDateDatesModal(user, year) {
      user.januariPoDate = []
      user.februariPoDate = []
      user.maretPoDate = []
      user.aprilPoDate = []
      user.meiPoDate = []
      user.juniPoDate = []
      user.juliPoDate = []
      user.agustusPoDate = []
      user.septemberPoDate = []
      user.oktoberPoDate = []
      user.novemberPoDate = []
      user.desemberPoDate = []

      const monthKeys = [
        'januariPoDate',
        'februariPoDate',
        'maretPoDate',
        'aprilPoDate',
        'meiPoDate',
        'juniPoDate',
        'juliPoDate',
        'agustusPoDate',
        'septemberPoDate',
        'oktoberPoDate',
        'novemberPoDate',
        'desemberPoDate',
      ]

      for (const j of user.programs) {
        const createdAt = j.createdAt
        const programDate = moment(createdAt)
        if (!createdAt || !programDate.isValid()) {
          continue
        }
        if (programDate.year() !== Number(year)) {
          continue
        }

        const monthIndex = programDate.month()
        const key = monthKeys[monthIndex]
        if (!key) {
          continue
        }

        const poDate = j.poDate
        user[key].push({
          date: poDate ? moment(poDate).format('DD-MMM-YYYY HH:mm:ss') : '-',
          createdAtLabel: moment(createdAt).format('DD-MMM-YYYY HH:mm:ss'),
          price: j.price ? j.price.name : '-',
          rawDate: poDate,
          id: j.id,
        })
      }
      return user
    },
    handleMakeFirstProgram(record) {
      // pastikan bentuknya array
      const programs = Array.isArray(record.programs) ? record.programs : []

      // sort ASC (paling lama duluan)
      const sorted = [...programs].sort((a, b) => {
        const da = a.createdAt ? moment(a.createdAt) : 0
        const db = b.createdAt ? moment(b.createdAt) : 0
        return da - db
      })

      // kalau mau ambil program pertama (paling lama)
      const firstProgram = sorted[0] || null
      return moment(firstProgram.createdAt).format('DD MMM YYYY HH:mm:ss')
      // lanjut apa pun yang kamu mau lakukan di sini
    },
    handleMakeLastProgram(record) {
      // pastikan bentuknya array
      const programs = Array.isArray(record.programs) ? record.programs : []

      // sort ASC (paling lama duluan)
      const sorted = [...programs]
        .filter(
          (e) =>
            (e.status === 0 && e.checkPoint === 6) ||
            (e.status === 1 && e.checkPoint === 5),
        )
        .sort((a, b) => {
          const da = a.drugsTakenDate ? moment(a.drugsTakenDate) : 0
          const db = b.drugsTakenDate ? moment(b.drugsTakenDate) : 0
          return db - da
        })

      // kalau mau ambil program pertama (paling lama)
      console.log(sorted, 'DISININ YAA')
      const lastProgram = sorted[0] || null
      if (!lastProgram) return '-'
      if (!lastProgram.drugsTakenDate) return '-'
      const redemptionDate = moment(lastProgram.drugsTakenDate)
      if (!redemptionDate.isValid()) return '-'
      const isNew = redemptionDate
        ? redemptionDate.isSameOrAfter(
            moment('2026-01-12', 'YYYY-MM-DD'),
            'day',
          )
        : false

      return `${moment(redemptionDate).format('DD MMM YYYY HH:mm:ss')}${
        isNew ? ' (new)' : ''
      }`
      // lanjut apa pun yang kamu mau lakukan di sini
    },
    insertByMonth(records, type = 'Perpanjang', field = 'createdAt', year) {
      const months = [
        'januari',
        'februari',
        'maret',
        'april',
        'mei',
        'juni',
        'juli',
        'agustus',
        'september',
        'oktober',
        'november',
        'desember',
      ]
      const monthKeys = months.map((m) => m + type)
      const seeded = (records.programs || []).map((r) => {
        const base = {}
        monthKeys.forEach((k) => (base[k] = '-'))
        return { ...base, ...r }
      })

      seeded.forEach((rec) => {
        const raw = rec[field]
        if (!raw) return
        const d = moment(raw)
        if (!d.isValid()) return

        // filter by selected year if provided
        if (year !== null && Number(d.year()) !== Number(year)) return

        const key = months[d.month()] + type
        rec[key] = d.format('DD-MMM-YYYY HH:mm:ss')
      })

      return seeded

      // prepare an object with all months as keys
      // const grouped = {}
      // months.forEach((m) => (grouped[m + type] = '-'))
      // //
      // records = records.map((m) => {
      //   return {
      //     ...m,
      //     ...grouped,
      //   }
      // })
      // records.forEach((rec) => {
      //   if (!rec[field]) return
      //   const date = new Date(rec[field])
      //   const monthIndex = date.getMonth() // 0 = Jan, 6 = Jul
      //   const monthKey = months[monthIndex]
      //   rec[monthKey + type] = moment(date).format('DD-MMM-YYYY HH:mm:ss')

      //   // grouped[monthKey].push(rec)
      // })

      // return records
    },
    isInMonth(date, year, monthIndex) {
      // monthIndex: 0 = Jan, 1 = Feb, ... 11 = Dec
      const d = moment(date)
      if (!d.isValid()) return false

      const start = moment({ year, month: monthIndex, day: 1 }).startOf('day')
      const end = start.clone().endOf('month') // otomatis jadi tgl terakhir bulan itu

      // '[]' artinya inklusif (>= start && <= end)
      return d.isBetween(start, end, 'day', '[]')
    },
    listRedemptionDatesModal(user, year) {
      const months = [
        'januari',
        'februari',
        'maret',
        'april',
        'mei',
        'juni',
        'juli',
        'agustus',
        'september',
        'oktober',
        'november',
        'desember',
      ]

      // reset arrays for each month
      months.forEach((m) => {
        user[m] = []
      })

      const programs = Array.isArray(user.programs) ? user.programs : []

      for (const program of programs) {
        const redemption = program.red
        const monthIndex = moment(redemption).isValid()
          ? moment(redemption).month()
          : null

        if (
          monthIndex !== null &&
          this.isInMonth(redemption, Number(year), monthIndex)
        ) {
          const key = months[monthIndex]
          const d = moment(redemption)
          const dateStr = redemption ? d.format('DD-MM-YYYY') : '-'
          const isNew = redemption
            ? d.isSameOrAfter(moment('2026-01-12', 'YYYY-MM-DD'), 'day')
            : false
          const priceStr = program.price ? program.price.name : '-'

          user[key].push({
            date: `${dateStr}${isNew ? ' (new)' : ''}`,
            price: priceStr,
          })
        }
      }

      return user
    },
    async onSearch(searchText) {
      this.pagination.current = 1
      if (searchText !== '') {
        await this.getAllPatient(this.filterProgram)
        // this.filteredData = filteredData
      } else {
        // this.filteredData = this.items
        await this.getAllPatient(this.filterProgram)
      }
    },
    getRole() {
      const role = window.localStorage.getItem('role')
      if (role === 'admin' || role === 'apl' || role === 'astrazeneca') {
        this.isAdmin = true
      }
    },
    getStatus(isTerminated, record) {
      if (record.computedStatus) {
        return record.computedStatus
      }

      // Fallback for when computedStatus is not yet available (or during load)
      let message = ''

      if (!record.program) message = 'Belum Terdaftar'
      else if (
        record.program &&
        record.isApproved &&
        record.isTerminated !== true &&
        record.checkPoint !== 6 &&
        record.program.isDrugsTaken !== true
      )
        message = 'Belum Scan QR'
      else if (
        record.program &&
        record.program.isApproved &&
        record.program.checkPoint !== 6 &&
        !record.program.prevProgram &&
        !record.program.isTerminated &&
        record.program.isDrugsTaken &&
        record.program.reminderDate &&
        moment(record.program.reminderDate).isAfter(moment())
      )
        message = 'Pasien Baru'
      else if (
        record.program.prevProgram &&
        record.program.isTerminated !== true &&
        record.program.isDrugsTaken === true &&
        record.program.reminderDate &&
        moment(record.program.reminderDate).isAfter(moment())
      )
        message = 'Perpanjang'
      else if (
        record.program &&
        record.program.isApproved &&
        record.program.isTerminated !== true &&
        record.program.checkPoint === 5 &&
        record.program.reminderDate &&
        moment(record.program.reminderDate).isBefore(
          moment().subtract(2, 'months'),
        )
      )
        message = 'Tidak Aktif'
      else if (record.program.isTerminated) message = 'Berhenti'
      else message = 'Belum Terdaftar'

      return message
    },
    async convertExcel(e) {
      var reader = new FileReader()
      reader.readAsArrayBuffer(e.file.originFileObj)
      reader.onload = async (e) => {
        var data = new Uint8Array(reader.result)
        var wb = XLSX.read(data, { type: 'array' })
        var htmlstr = XLSX.write(wb, {
          sheet: wb.SheetNames[0],
          type: 'binary',
          bookType: 'html',
        })
        const jsonTables = HtmlTableToJson.parse(htmlstr)
        const tableExcel = jsonTables.results[0]
        for (const i in tableExcel) {
          const cell = tableExcel[i]
          cell.store_name = `Apotek ${cell.CUSTOMER_NAME}`
          cell.store_name = cell.store_name.replaceAll('AP', '')
          cell.store_name = cell.store_name.replaceAll('.', '')
          cell.store_name = cell.store_name.replaceAll(',', ' ')
          cell.city = cell.BRANCH.replaceAll('PT. APL ', '')
          cell.city = cell.city.replaceAll(' 1', '').toLowerCase()
          cell.city = cell.city.charAt(0).toUpperCase() + cell.city.slice(1)
          const addressRaw = `${cell.ADDRESS}`.toUpperCase()
          const containsCity = addressRaw.includes(cell.city.toUpperCase())
          if (!containsCity) {
            cell.address = `${cell.ADDRESS} ${cell.city}`
          } else {
            cell.address = cell.ADDRESS
          }
          // if (unlisted.includes(cell.store_name)) {
          //   filteredTables.push(cell)
          // }
        }
        // eslint-disable-next-line
        //
      }
    },
    async migrateDoctor(e) {
      var reader = new FileReader()
      //
      reader.readAsArrayBuffer(e.file.originFileObj)
      reader.onload = async (e) => {
        var data = new Uint8Array(reader.result)
        var wb = XLSX.read(data, { type: 'array' })
        var htmlstr = XLSX.write(wb, {
          sheet: wb.SheetNames[1],
          type: 'binary',
          bookType: 'html',
        })
        const jsonTables = HtmlTableToJson.parse(htmlstr)
        // eslint-disable-next-line
        const tableExcel = jsonTables.results[0]
        // for (const i in tableExcel) {
        // }
        //
      }
    },
    async convertTable(e) {
      var reader = new FileReader()
      //
      reader.readAsArrayBuffer(e.file.originFileObj)
      reader.onload = async (e) => {
        var data = new Uint8Array(reader.result)
        var wb = XLSX.read(data, { type: 'array' })
        var htmlstr = XLSX.write(wb, {
          sheet: wb.SheetNames[0],
          type: 'binary',
          bookType: 'html',
        })
        const jsonTables = HtmlTableToJson.parse(htmlstr)
        const tableExcel = jsonTables.results[0]
        tableExcel.forEach((x) => {
          if (x.Pasien) {
            const patient = x.Pasien.replaceAll('-', '')
            x.Pasien = patient
          }
          if (x.Pasien === '2020SMG246')
            if (x['Enroll Date'] && x['Enroll Date'] !== 'null') {
              // x['Enroll Date'] = x['Tanggal Bergabung']
              const enrollDate = x['Enroll Date']
              let enrollDateResult = ''
              enrollDateResult = moment(enrollDate).format('DD/MM/YYYY')
              if (enrollDateResult === 'Invalid date') {
                enrollDateResult = moment(enrollDate, 'DD/MM/YYYY').format(
                  'DD/MM/YYYY',
                )
              }
              //   // if (enrollDate.includes(',')) {
              //   //   const replaced = enrollDate.replace(',', '')
              //   //   x['Enroll Date'] = moment(replaced, 'DD/MM/YYYY').format('YYYY-MM-DD')
              //   // } else if (enrollDate.includes('.')) {
              //   //   const replaced = enrollDate.replace('.', '').trim()
              //   //   x['Enroll Date'] = moment(replaced, 'DD/MM/YYYY').format('YYYY-MM-DD')
              //   //   if (x.Pasien === '021-PWK-399')
              //   //   if (x.Pasien === '021-PWK-399')
              //   // } else if (enrollDate.includes('/')) {
              //   //   x['Enroll Date'] = moment(enrollDate, 'DD/MM/YYYY[T]HH:mm:ss').format('YYYY-MM-DD')
              //   // } else {
              //   //   x['Enroll Date'] = moment(enrollDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
              //   // }
              x['Enroll Date'] = enrollDateResult
            }
          if (x['Januari 2021'] && x['Januari 2021'] !== '') {
            let redemption = x['Januari 2021']
            if (redemption.includes(',')) {
              const replaced = redemption.replace(',', '')
              redemption = replaced
            }
            if (redemption.includes('.')) {
              const replaced = redemption.replace('.', '')
              redemption = replaced
            }
            x['Januari 2021'] = redemption
            const words = redemption.split(' ')
            x[36] =
              words[0] && words[0] !== '.'
                ? moment(words[0], 'DD-MM-YYYY').format('YYYY-MM-DD')
                : ''
            if (words[1]) {
              const price = words[1].match(/\d/g)
              if (price) {
                if (price.length > 1) {
                  x.price13 = price.join('')
                } else {
                  x.price13 = price[0]
                }
              }
            }
            // x.price13 = words[1] ? words[1].match(/\d+/)[0] : ''
          }
          if (x['Februari 2021'] && x['Februari 2021'] !== '') {
            let redemption = x['Februari 2021']
            if (redemption.includes(',')) {
              const replaced = redemption.replace(',', '')
              redemption = replaced
            }
            if (redemption.includes('.')) {
              const replaced = redemption.replace('.', '')
              redemption = replaced
            }
            x['Februari 2021'] = redemption
            const words = redemption.split(' ')
            x[37] =
              words[0] && words[0] !== '.'
                ? moment(words[0], 'DD-MM-YYYY').format('YYYY-MM-DD')
                : ''
            if (words[1]) {
              const price = words[1].match(/\d/g)
              if (price) {
                if (price.length > 1) {
                  x.price14 = price.join('')
                } else {
                  x.price14 = price[0]
                }
              }
            }
            // x.price14 = words[1] ? words[1].match(/\d+/)[0] : ''
          }
          if (x['Maret 2021'] && x['Maret 2021'] !== '') {
            let redemption = x['Maret 2021']
            if (redemption.includes(',')) {
              const replaced = redemption.replace(',', '')
              redemption = replaced
            }
            if (redemption.includes('.')) {
              const replaced = redemption.replace('.', '')
              redemption = replaced
            }
            x['Maret 2021'] = redemption
            const words = redemption.split(' ')
            x[38] =
              words[0] && words[0] !== '.'
                ? moment(words[0], 'DD-MM-YYYY').format('YYYY-MM-DD')
                : ''
            if (words[1]) {
              const price = words[1].match(/\d/g)
              if (price) {
                if (price.length > 1) {
                  x.price15 = price.join('')
                } else {
                  x.price15 = price[0]
                }
              }
            }
            // x.price15 = words[1] ? words[1].match(/\d+/)[0] : ''
          }
          if (x['April 2021'] && x['April 2021'] !== '') {
            let redemption = x['April 2021']
            if (redemption.includes(',')) {
              const replaced = redemption.replace(',', '')
              redemption = replaced
            }
            if (redemption.includes('.')) {
              const replaced = redemption.replace('.', '')
              redemption = replaced
            }
            x['April 2021'] = redemption
            const words = redemption.split(' ')
            x[39] =
              words[0] && words[0] !== '.'
                ? moment(words[0], 'DD-MM-YYYY').format('YYYY-MM-DD')
                : ''
            if (words[1]) {
              const price = words[1].match(/\d/g)
              if (price) {
                if (price.length > 1) {
                  x.price16 = price.join('')
                } else {
                  x.price16 = price[0]
                }
              }
            }
            // x.price16 = words[1] ? words[1].match(/\d+/)[0] : ''
          }
          if (x['Mei 2021'] && x['Mei 2021']) {
            let redemption = x['Mei 2021']
            if (redemption.includes(',')) {
              const replaced = redemption.replace(',', '')
              redemption = replaced
            }
            if (redemption.includes('.')) {
              const replaced = redemption.replace('.', '')
              redemption = replaced
            }
            x['Mei 2021'] = redemption
            const words = redemption.split(' ')
            x[40] =
              words[0] && words[0] !== '.'
                ? moment(words[0], 'DD-MM-YYYY').format('YYYY-MM-DD')
                : ''
            if (words[1]) {
              const price = words[1].match(/\d/g)
              if (price) {
                if (price.length > 1) {
                  x.price17 = price.join('')
                } else {
                  x.price17 = price[0]
                }
              }
            }
            // x.price16 = words[1] ? words[1].match(/\d+/)[0] : ''
          }
          if (x['Juni 2021'] && x['Juni 2021']) {
            let redemption = x['Juni 2021']
            if (redemption.includes(',')) {
              const replaced = redemption.replace(',', '')
              redemption = replaced
            }
            if (redemption.includes('.')) {
              const replaced = redemption.replace('.', '')
              redemption = replaced
            }
            x['Juni 2021'] = redemption
            const words = redemption.split(' ')
            x[41] =
              words[0] && words[0] !== '.'
                ? moment(words[0], 'DD-MM-YYYY').format('YYYY-MM-DD')
                : ''
            if (words[1]) {
              const price = words[1].match(/\d/g)
              if (price) {
                if (price.length > 1) {
                  x.price18 = price.join('')
                } else {
                  x.price18 = price[0]
                }
              }
            }
            // x.price16 = words[1] ? words[1].match(/\d+/)[0] : ''
          }
          for (let i = 1; i <= 35; i++) {
            if (x[i] && x[i] !== '') {
              let redemption = x[i].replace(/\s/g, '')
              if (x.Pasien === '2020SMG247' && i === 29)
                if (redemption.includes(',')) {
                  const replaced = redemption.replaceAll(',', '')
                  redemption = replaced
                }
              if (redemption.includes('.')) {
                const replaced = redemption.replaceAll('.', '')
                redemption = replaced
              }
              if (redemption.includes('(')) {
                const replaced = redemption.replaceAll('(', '')
                redemption = replaced
              }
              if (redemption.includes(')')) {
                const replaced = redemption.replaceAll(')', '')
                redemption = replaced
              }
              const words = redemption.split(' ')
              let redemptionDate = ''
              if (redemption.includes('/')) {
                redemptionDate = moment(words[0], 'DD/MM/YYYY').format(
                  'DD-MM-YYYY',
                )
                if (redemptionDate === 'Invalid date') {
                  redemptionDate = moment(words[0], 'M-DD-YY').format(
                    'DD-MM-YYYY',
                  )
                }
              } else {
                redemptionDate = moment(words[0], 'DD-MM-YYYY').format(
                  'DD-MM-YYYY',
                )
                if (redemptionDate === 'Invalid date') {
                  redemptionDate = moment(words[0], 'DD-MMM-YY').format(
                    'DD-MM-YYYY',
                  )
                }
              }
              x[i] =
                words[0] &&
                words[0] !== '.' &&
                words[0] !== ' ' &&
                words[0] !== null
                  ? redemptionDate
                  : ''
              if (words[1]) {
                const price = words[1].match(/\d/g)
                if (price) {
                  if (price.length > 1) {
                    x[`price${i}`] = price.join('')
                  } else {
                    x[`price${i}`] = price[0]
                  }
                }
              }
            }
          }
          if (x.Pasien === '2020SMG246')
            x['Tanggal Berhenti'] = x['Terminate (Month)']
          if (x['Tanggal Berhenti'] && x['Tanggal Berhenti'] !== 'null') {
            const terminatedDate = `01-${x['Tanggal Berhenti']}`
            x['Tanggal Berhenti'] = moment(terminatedDate, 'DD-MMM-YY').format(
              'YYYY-MM-DD',
            )
            if (x.Pasien === '2019MKS151') {
            }
          }
          if (x.Penyebab === 'Lain-lain') {
            x.Penyebab = 'lain-lain'
          }
        })
      }
    },
    async bulk() {
      // eslint-disable-next-line
      const res = await bulkCreate()
      //
    },
    async getAllPatient(role) {
      const requestId = ++this.patientRequestId
      this.isLoading = true
      try {
        const queryCondition = {
          page: this.pagination.current,
          pageSize: this.pagination.pageSize,
          year: this.year,
          month: this.month.length ? this.month.join(',') : undefined,
          poDateMonth: this.poDateMonth,
        }
        if (this.filterBycode) {
          queryCondition.code = this.filterBycode
        }
        if (this.selectedStatusFilters) {
          queryCondition.status = this.selectedStatusFilters
        }
        if (this.selectedPharmacyFilters.length) {
          queryCondition.pharmacy = this.selectedPharmacyFilters.join(',')
        }

        const result = await apiClient.get(
          `/patient/all?type=${this.filterProgram}`,
          {
            params: queryCondition,
          },
        )

        if (requestId !== this.patientRequestId) return
        if (!result || !result.data || !Array.isArray(result.data.patients)) {
          throw new Error('Respons daftar pasien tidak valid')
        }

        const res = result.data.patients.filter((el) => el.code !== null)
        this.pagination.total = result.data.total
        this.pagination.pageSize = result.data.pageSize
        this.pagination.current = result.data.page
        this.$store.commit('SET_PAGE_PATIENT', {
          page: result.data.page,
          pageSize: result.data.pageSize,
          total: result.data.total,
        })
        this.totalDoT = 0
        this.meanDoT = 0
        this.medianDoT = 0
        const cityFilters = []
        const filtersComparison = []
        const doctorFilters = []
        const deathFilters = []
        const pharmacyFilters = []
        if (res.length) {
          // let x1 = 0
          // let x2 = 0
          this.filteredData = res
          for (const i in res) {
            let isApproved = false
            let user = res[i]
            const duplicateTestLab = []
            const testLabs = []
            user.programs = user.programs.filter(
              (p) => !(p.status === 0 && p.checkPoint === 1),
            )
            if (user.city) {
              const comparison = user.city.toUpperCase()
              if (!filtersComparison.includes(comparison)) {
                cityFilters.push(user.city)
                filtersComparison.push(comparison)
              }
            }
            if (user.testLabs && user.testLabs.length) {
              user.testLabs.forEach((el) => {
                const comparison = el?.testLabType?.name.toUpperCase()
                if (!duplicateTestLab.includes(comparison)) {
                  testLabs.push(el?.testLabType?.name)
                  duplicateTestLab.push(comparison)
                }
              })
              user.testLabs = testLabs
            }

            user = this.listRedemptionDates(user)
            user.mad = 0
            if (user.program) {
              if (user.program.programType) {
                user.programType = user.program.programType.name
              }
              user.isProgramNull = false
              if (user.program.price && user.program.drugsTakenDate) {
                // const medicineCount = user.program.price.count
                // const pillsTaken = await listAllTakenPills(
                //   user.id,
                //   user.program.drugsTakenDate,
                // )
                // user.mad = (pillsTaken.pillsTaken / medicineCount) * 100
                // user.prescription = medicineCount
                // user.takenpills = pillsTaken.pillsTaken
              }
              if (user.program.doctor) {
                if (!doctorFilters.includes(user.program.doctor.fullname)) {
                  doctorFilters.push(user.program.doctor.fullname)
                }
              }
              if (
                user.program.terminatedMessage &&
                user.program.terminatedMessage !== 'null'
              ) {
                if (!deathFilters.includes(user.program.terminatedMessage)) {
                  deathFilters.push(user.program.terminatedMessage)
                }
              }
              if (user.program.pharmacy) {
                if (!pharmacyFilters.includes(user.program.pharmacy.name)) {
                  pharmacyFilters.push(user.program.pharmacy.name)
                }
              }
              user.isTerminated = null
              user.prevProgram = null
              user.terminatedMessage = null
              if (!user.program.doctor) {
                user.program.doctor = { fullname: '-' }
                user.doctor = { fullname: '-' }
                user.doctorName = '-'
              } else {
                user.doctor = user.program.doctor
                user.doctorName = user.program.doctor.fullname
              }
              if (!user.program.checkPoint) {
                user.checkPoint = ''
              } else {
                user.checkPoint = user.program.checkPoint
              }
              if (!user.program.isApproved) {
                isApproved = false
              } else {
                isApproved = true
              }
              if (!user.program.pharmacy) {
                user.program.pharmacy = { name: '-' }
                user.pharmacy = { name: '-' }
                user.pharmacyName = ''
              } else {
                user.pharmacy = user.program.pharmacy
                user.pharmacyName = user.program.pharmacy.name
              }
              if (!user.program.prevProgram) {
                user.isPrevProgramNull = true
              } else {
                user.isPrevProgramNull = false
              }
              if (user.checkPoint === 6) {
                user.isCheckPointSix = true
              } else {
                user.isCheckPointSix = false
              }
              if (user.program.isTerminated)
                user.isTerminated = user.program.isTerminated
              if (user.program.terminatedMessage === 'null')
                user.program.terminatedMessage = '-'
              if (user.program.prevProgram)
                user.prevProgram = user.program.prevProgram
              if (user.program.terminatedMessage)
                user.terminatedMessage = user.program.terminatedMessage
              // if (user.program.isTerminated)
            } else {
              user.isProgramNull = true
              isApproved = false
            }
            if (user.programs) {
              for (const i of user.programs) {
                i.red = i.drugsTakenDate
              }
              // const result = user.programs.reduce((unique, o) => {
              //   if (
              //     !unique.some(
              //       (obj) =>
              //         moment(obj.red).format('YYYY/MM/DD') ===
              //         moment(o.red).format('YYYY/MM/DD'),
              //     )
              //   ) {
              //     unique.push(o)
              //   }
              //   return unique
              // }, [])
              //
              user.dot = user.programs.length
              this.totalDoT += user.dot
              // const mid = Math.ceil(filteredDot.length / 2)
              // const median = filteredDot.length % 2 === 0 ?
              // x1 = res[res.length / 2].dot
              // x2 = res[(res.length / 2) + 1].dot
              // this.meanDoT = this.totalDoT / res.length
              // this.medianDoT = (x1 + x2) / 2
              // this.$store.state.medianDoT = this.medianDoT
            } else {
              user.dot = 0
            }

            user.isApproved = isApproved
            this.filteredData = res
          }
          const filteredDot = []
          for (const i in res) {
            if (res[i].dot !== null) {
              filteredDot.push(res[i].dot)
            }
          }
          const filteredDotSort = filteredDot.sort((a, b) => a - b)
          const len = filteredDot.length
          const sum = filteredDot.reduce((sum, val) => sum + val, 0)
          const mid = Math.ceil(len / 2)
          const median =
            len % 2 === 0
              ? (filteredDotSort[mid] + filteredDotSort[mid - 1]) / 2
              : filteredDotSort[mid - 1]
          this.medianDoT = median
          this.meanDoT = sum / len
          this.$store.state.medianDoT = this.medianDoT
          this.$store.state.meanDoT = this.meanDoT
          this.$store.state.totalDoT = this.totalDoT
          this.cityFilters = cityFilters
          this.doctorFilters = doctorFilters
          this.deathCauseFilters = deathFilters
          this.pharmacyFilters = pharmacyFilters
          this.$store.state.cityFilters = cityFilters
          this.$store.state.doctorFilters = doctorFilters
          this.$store.state.deathCauseFilters = deathFilters
          this.$store.state.pharmacyFilters = pharmacyFilters
          // this.columns = columns
          this.$store.state.patientData = res
          this.items = res
          this.filteredData = res
        } else {
          this.filteredData = res
          this.$store.state.patientData = res
          this.items = res
          this.cityFilters = cityFilters
          this.doctorFilters = doctorFilters
          this.deathCauseFilters = deathFilters
          this.pharmacyFilters = pharmacyFilters
          this.$store.state.cityFilters = cityFilters
          this.$store.state.doctorFilters = doctorFilters
          this.$store.state.deathCauseFilters = deathFilters
          this.$store.state.pharmacyFilters = pharmacyFilters
        }
      } catch (error) {
        if (requestId === this.patientRequestId) {
          this.pagination.total = 0
          this.filteredData = []
          this.items = []
          this.$store.state.patientData = []
        }
        console.error('Gagal memuat daftar pasien:', error)
      } finally {
        if (requestId === this.patientRequestId) {
          this.isLoading = false
        }
      }
    },
    async listPillsTaken(user) {
      const enrollDate = user.program.drugsTakenDate
      const today = new Date()

      const diff = moment(today).diff(enrollDate)
      const seconds = diff / 1000
      const minutes = seconds / 60
      const hours = minutes / 60
      const days = hours / 24
      const pills = await listAllPillsStatus(
        user.id,
        parseInt(days),
        enrollDate,
        user.program.price.count,
      )
      this.pills = pills
    },
    onFilter(items) {
      //     selectedDoctorFilter: '',
      // selectedCityFilter: '',
      // selectedPharmacyFilters: '',
      // selectedStatusFilters: '',
      // selectedDeathCauseFilters: '',
      const filters = {
        // city: this.selectedCityFilter,
        // terminatedMessage: this.selectedDeathCauseFilters,
        // pharmacy: this.selectedPharmacyFilters,
        // record.program && record.checkPoint !== 6 && record.prevProgram === null && record.isTerminated === null)
      }
      if (this.selectedCityFilter.length > 0) {
        filters.city = this.selectedCityFilter
      }
      if (this.selectedDeathCauseFilters.length > 0) {
        filters.terminatedMessage = this.selectedDeathCauseFilters
      }
      if (this.selectedPharmacyFilters.length > 0) {
        filters.pharmacyName = this.selectedPharmacyFilters
      }
      if (this.selectedDoctorFilter.length > 0) {
        filters.doctorName = this.selectedDoctorFilter
      }
      //
      //
      this.filteredData = items.filter((item) => {
        for (var key in filters) {
          if (!filters[key].includes(item[key])) {
            return false
          }
        }
        return true
      })
      //
      // if (this.selectedStatusFilters) {
      //   this.statusFilter(this.filteredData)
      // }
    },
    async statusFilter(items) {
      if (this.selectedStatusFilters) {
        const value = this.selectedStatusFilters
        if (value === 'Belum Terdaftar')
          // this.filteredData = items.filter((record) => record.program === null)
          await this.getAllPatient(this.filterProgram, 'not_yet')
        else if (value === 'Belum Scan QR')
          // this.filteredData = items.filter(
          //   (record) =>
          //     record.program &&
          //     record.isApproved &&
          //     record.isTerminated !== true &&
          //     record.checkPoint !== 6 &&
          //     record.program.isDrugsTaken !== true,
          // )
          await this.getAllPatient(this.filterProgram, 'un_scanned')
        else if (value === 'Tidak Aktif')
          await this.getAllPatient(this.filterProgram, 'not_active')
        else if (value === 'Reactive')
          await this.getAllPatient(this.filterProgram, 'reactive')
        // this.filteredData = items.filter(
        //   (record) =>
        //     record.program &&
        //     record.isApproved &&
        //     record.isTerminated !== true &&
        //     record.checkPoint !== 6 &&
        //     record.program.reminderDate &&
        //     moment(record.program.reminderDate).isBefore(
        //       moment().subtract(2, 'months'),
        //     ),
        // )
        else if (value === 'Pasien Baru')
          await this.getAllPatient(this.filterProgram, 'new_patient')
        // this.filteredData = items.filter(
        //   (record) =>
        //     record.program &&
        //     record.checkPoint !== 6 &&
        //     record.prevProgram === null &&
        //     record.isTerminated === null &&
        //     record.program.isDrugsTaken === true,
        // )
        else if (value === 'Perpanjang')
          await this.getAllPatient(this.filterProgram, 'continuing')
        // this.filteredData = items.filter(
        //   (record) =>
        //     record.prevProgram &&
        //     record.isTerminated !== true &&
        //     record.program.isDrugsTaken === true,
        // )
        else if (value === 'Berhenti')
          await this.getAllPatient(this.filterProgram, 'stop')
        // this.filteredData = items.filter((record) => record.isTerminated)
      }
    },
    getProgramtype(id) {
      switch (id) {
        case '3a1845a1-28df-403d-a40d-e8173f511fc9':
          return 'TAGRISSO'
        case 'f20ef325-c767-444c-927d-71d4c3600f67':
          return 'FASLODEX'
        case '579d64ca-8ba8-458b-9534-47207e86a6a6':
          return 'LYNPARZA'
        default:
          return '-'
      }
    },
    // onStatusFilters (value) {
    //   if (value) {
    //     if (value === 'Belum Terdaftar') this.filteredData = this.items.filter(record => record.program === null)
    //     else if (value === 'Pasien Baru') this.filteredData = this.items.filter(record => record.program && record.checkPoint !== 6 && record.prevProgram === null && record.isTerminated === null)
    //     else if (value === 'Perpanjang') this.filteredData = this.items.filter(record => record.prevProgram && record.isTerminated !== true)
    //     else if (value === 'Berhenti') this.filteredData = this.items.filter(record => record.isTerminated)
    //   } else {
    //     this.filteredData = this.items
    //   }
    // },
    // onDoctorFilters (value) {
    //   if (value) {
    //     this.filteredData = this.items.filter(record => record.doctorName === value)
    //   } else {
    //     this.filteredData = this.items
    //   }
    // },
    // onPharmacyFilters (value) {
    //   if (value) {
    //     this.filteredData = this.items.filter(record => record.pharmacyName === value)
    //   } else {
    //     this.filteredData = this.items
    //   }
    // },
    // onDeathCauseFilters (value) {
    //   if (value) {
    //     this.filteredData = this.items.filter(record => record.terminatedMessage && record.terminatedMessage === value)
    //   } else {
    //     this.filteredData = this.items
    //   }
    // },
    viewDetails(id) {
      router.push('/pasien/details/' + id)
    },
    listRedemptionDates(user) {
      user.januari = '-'
      user.februari = '-'
      user.maret = '-'
      user.april = '-'
      user.mei = '-'
      user.juni = '-'
      user.juli = '-'
      user.agustus = '-'
      user.september = '-'
      user.oktober = '-'
      user.november = '-'
      user.desember = '-'
      user.years = []
      const yearDuplicate = []
      for (const j of user.programs) {
        // const redemption = j.enrollDate ? j.enrollDate : j.createdAt
        const redemption = j.drugsTakenDate
        const program = j
        const comparison = moment(redemption).year()
        if (!yearDuplicate.includes(comparison)) {
          user.years.push(comparison)
          yearDuplicate.push(comparison)
        }

        if (
          moment(redemption).isBefore(`${this.year}-01-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-01-01`, 'day')
        ) {
          user.januariPriceName = program.price ? program.price.name : '-'
          user.januari = redemption
            ? moment(redemption).format('DD-MM-YYYY')
            : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-02-28`, 'day') &&
          moment(redemption).isAfter(`${this.year}-02-01`, 'day')
        ) {
          user.februari =
            redemption !== null ? moment(redemption).format('DD-MM-YYYY') : '-'
          user.februariPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-03-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-03-01`, 'day')
        ) {
          user.maret = moment(redemption).format('DD-MM-YYYY')
          user.maretPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-04-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-04-01`, 'day')
        ) {
          user.april = moment(redemption).format('DD-MM-YYYY')
          user.aprilPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-05-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-05-01`, 'day')
        ) {
          user.mei = moment(redemption).format('DD-MM-YYYY')
          user.meiPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-06-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-06-01`, 'day')
        ) {
          user.juni = moment(redemption).format('DD-MM-YYYY')
          user.juniPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-07-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-07-01`, 'day')
        ) {
          user.juli = moment(redemption).format('DD-MM-YYYY')
          user.juliPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-08-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-08-01`, 'day')
        ) {
          user.agustus = moment(redemption).format('DD-MM-YYYY')
          if (user.code === '2021JAM003') {
          }
          user.agustusPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-09-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-09-01`, 'day')
        ) {
          user.september = moment(redemption).format('DD-MM-YYYY')
          user.septemberPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-10-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-10-01`, 'day')
        ) {
          user.oktober = moment(redemption).format('DD-MM-YYYY')
          user.oktoberPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-11-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-11-01`, 'day')
        ) {
          user.november = moment(redemption).format('DD-MM-YYYY')
          user.novemberPriceName = program.price ? program.price.name : '-'
        }
        if (
          moment(redemption).isBefore(`${this.year}-12-30`, 'day') &&
          moment(redemption).isAfter(`${this.year}-12-01`, 'day')
        ) {
          user.desember = moment(redemption).format('DD-MM-YYYY')
          user.desemberPriceName = program.price ? program.price.name : '-'
        }
      }
      return user
    },
    onChangeTable(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize

      this.$router.push({
        name: 'Table Patient',
        query: {
          ...this.$route.query,
          page: pagination.current,
          pageSize: pagination.pageSize,
        },
      })
      this.$store.commit('SET_PAGE_PATIENT', {
        page: pagination.current,
        pageSize: pagination.pageSize,
        total: this.pagination.total,
      })
      // Optionally handle sorter and filters if your backend supports them
      // const role =
      //   this.user.role !== 'admin' && this.user.role !== 'astrazeneca'
      //     ? this.user.role
      //     : ''
      this.getAllPatient()
    },
    async getProgramTypeAll() {
      const res = await getProgramTypeAll()
      this.programTypeItems = res.data
    },
    async getPharmacyAll() {
      const res = await apiClient.get('/pharmacy')
      this.pharmacyItems = res.data
    },
    getPharmacyLabel(pharmacy) {
      if (!pharmacy) return ''
      return pharmacy.city
        ? `${pharmacy.name} — ${pharmacy.city}`
        : pharmacy.name
    },
    getPharmacyTagPlaceholder(omittedValues) {
      return `+${omittedValues.length} farmasi`
    },
    onPharmacyChanged() {
      this.pagination.current = 1
      this.getAllPatient()
    },
    onStatusChanged() {
      this.pagination.current = 1
      this.getAllPatient(this.filterProgram)
    },
    handleChangeProgram(value) {
      this.pagination.current = 1
      this.getAllPatient(value)
    },
    async downloadData(record) {
      const res = await apiClient.post(
        '/patient/export',
        {
          ids: [record.id],
        },
        { responseType: 'blob' },
      )
      const blob = new Blob([res.data], { type: 'text/csv' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'patients.csv'
      document.body.appendChild(link) // Safari needs it in the DOM
      link.click()

      // 4️⃣  Clean up after ourselves
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    async bulkDownloadData() {
      try {
        this.isLoading = true
        const queryCondition = { ...this.$route.query }

        // Append filters mirroring getAllPatient logic
        if (this.year) queryCondition.year = this.year
        if (this.month.length) queryCondition.month = this.month.join(',')
        if (this.poDateMonth) queryCondition.poDateMonth = this.poDateMonth
        if (this.filterBycode) queryCondition.code = this.filterBycode
        if (this.selectedStatusFilters)
          queryCondition.status = this.selectedStatusFilters

        if (
          this.selectedPharmacyFilters &&
          this.selectedPharmacyFilters.length > 0
        ) {
          queryCondition.pharmacy = this.selectedPharmacyFilters.join(',')
        }

        if (this.filterProgram && this.filterProgram !== 'Semua') {
          queryCondition.type = this.filterProgram
        } else if (
          this.user.role !== 'admin' &&
          this.user.role !== 'astrazeneca'
        ) {
          queryCondition.type = this.user.role
        }

        // Send GET request to the exportByMonth endpoint
        const res = await apiClient.get('/patient/exportCycle', {
          params: queryCondition,
          responseType: 'blob',
        })
        // const res = await apiClient.get('/patient/exportByMonth', {
        //  params: queryCondition,
        //  responseType: 'blob',
        // })

        const blob = new Blob([res.data], { type: 'text/csv' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `patients_export_${new Date().getTime()}.csv`
        document.body.appendChild(link) // Safari needs it in the DOM
        link.click()

        // Clean up
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      } catch (err) {
        this.$notification.error({
          message: 'Error',
          description: 'Gagal mendownload data.',
        })
        console.error(err)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
<style lang="scss" module>
@import './style.module.scss';
</style>
